const prefix = 'PROJECTS_SETTINGS';

export const GET_NOTE_TEMPLATE_FOLDERS = Symbol(`${prefix}/GET_NOTE_TEMPLATE_FOLDERS`);
export const GET_NOTE_TEMPLATE_FOLDERS_SUCCESS = Symbol(`${prefix}/GET_NOTE_TEMPLATE_FOLDERS_SUCCESS`);
export const GET_NOTE_TEMPLATE_FOLDERS_FAIL = Symbol(`${prefix}/GET_NOTE_TEMPLATE_FOLDERS_FAIL`);

export const CREATE_NOTE_TEMPLATE_FOLDER = Symbol(`${prefix}/CREATE_NOTE_TEMPLATE_FOLDER`);
export const CREATE_NOTE_TEMPLATE_FOLDER_SUCCESS = Symbol(`${prefix}/CREATE_NOTE_TEMPLATE_FOLDER_SUCCESS`);
export const CREATE_NOTE_TEMPLATE_FOLDER_FAIL = Symbol(`${prefix}/CREATE_NOTE_TEMPLATE_FOLDER_FAIL`);

export const DELETE_NOTE_TEMPLATE_FOLDER = Symbol(`${prefix}/DELETE_NOTE_TEMPLATE_FOLDER`);
export const DELETE_NOTE_TEMPLATE_FOLDER_SUCCESS = Symbol(`${prefix}/DELETE_NOTE_TEMPLATE_FOLDER_SUCCESS`);
export const DELETE_NOTE_TEMPLATE_FOLDER_FAIL = Symbol(`${prefix}/DELETE_NOTE_TEMPLATE_FOLDER_FAIL`);

export const UPDATE_NOTE_TEMPLATE_FOLDER = Symbol(`${prefix}/UPDATE_NOTE_TEMPLATE_FOLDER`);
export const UPDATE_NOTE_TEMPLATE_FOLDER_SUCCESS = Symbol(`${prefix}/UPDATE_NOTE_TEMPLATE_FOLDER_SUCCESS`);
export const UPDATE_NOTE_TEMPLATE_FOLDER_FAIL = Symbol(`${prefix}/UPDATE_NOTE_TEMPLATE_FOLDER_FAIL`);

export const REORDER_NOTE_TEMPLATE_FOLDERS = Symbol(`${prefix}/REORDER_NOTE_TEMPLATE_FOLDERS`);
export const REORDER_NOTE_TEMPLATE_FOLDERS_SUCCESS = Symbol(`${prefix}/REORDER_NOTE_TEMPLATE_FOLDERS_SUCCESS`);
export const REORDER_NOTE_TEMPLATE_FOLDERS_FAIL = Symbol(`${prefix}/REORDER_NOTE_TEMPLATE_FOLDERS_FAIL`);
